<template>
  <div class="bg-color-light position-relative">
    <vue-headful :title="doctitle" />
    <!---------------------------- SESSIONS --------------------------------------->
    <div style="position: sticky; top: 0; right: 0; z-index: 9999">
      <Toast
        v-if="showingToast"
        :message="'Removed'"
        :duration="2000"
        @hidden="showingToast = false"
      />
    </div>
    <b-container>
      <b-row>
        <b-col cols="12" lg="8" offset-lg="2" class="mb-5" style="z-index: 1">
          <h1 class="mt-5 mb-4">My schedule</h1>
          <div v-if="schedulecount === 0">
            <div class="mb-5">
              <h2>Oops!</h2>
              <p class="pb-5">
                Looks like you didn't add any sessions to your schedule yet, but
                don't worry,<br />just go to
                <b-link to="/line-up">Line-up</b-link> and use the add button to
                get started!
              </p>
            </div>
          </div>
          <div v-else>
            <div class="mb-4">
              <p class="mt-3" v-if="this.myscheduleid">
                All changes to your schedule are saved automatically, and you
                can always find its latest version at
                <a :href="'/my-schedule/' + this.myscheduleid"
                  >https://oredev.org/my-schedule/{{ this.myscheduleid }}</a
                >
                on any device. (You can find this link in your inbox.)
              </p>
              <p>
                We love it you are planning your Øredev experience with such
                care, that's precisely what we aspire at, too.
              </p>
              <a
                class="btn btn-schedule"
                v-if="this.revertmyschedule && !this.myscheduleid"
                @click="revertSchedule"
                >Revert to my schedule
                <i class="pl-1 material-icons align-middle">upload</i></a
              >
              <a
                class="btn btn-schedule"
                v-else-if="!this.myscheduleid"
                v-b-modal.saveschedule
                >Save my schedule
                <i class="pl-1 material-icons align-middle">download</i></a
              >
            </div>
            <h2>Your added sessions</h2>
            <div
              class="col-12"
              v-for="(session, index) in mySessions"
              :key="session.index"
            >
              <div v-if="displayDay(index)" class="row session active weekday">
                {{ getDay(session.sessionScheduleDay + "") }}
              </div>
              <div class="row session active">
                <div class="col-md-1 order-md-1 col-6 order-1">
                  <h5 style="padding-top: 16px">
                    {{ session.sessionScheduleTime }}
                  </h5>
                </div>
                <div class="session-content col-md-9 order-md-2 col-12 order-3">
                  <div class="row">
                    <div
                      class="col-12"
                      style="font-size: 14px; font-weight: 500"
                    >
                      <span>
                        {{ session.sessionSpeakerName }}
                      </span>
                    </div>
                  </div>
                  <div class="row mt-1 mb-1">
                    <div class="col-12">
                      <div
                        class="session-tag d-inline-block mr-1"
                        :class="
                          session.sessionTagMain === '.NET'
                            ? 'tag-NET'
                            : 'tag-' + session.sessionTagMain
                        "
                      >
                        <img
                          v-if="
                            session.sessionTagMain === 'DATA' ||
                            session.sessionTagMain === 'Security' ||
                            session.sessionTagMain === 'Web' ||
                            session.sessionTagMain === 'JVM'
                          "
                          src="https://res.cloudinary.com/oredev/image/upload/v1716803685/2024/Icons.svg/canvas.svg"
                        />
                        <img
                          v-else
                          src="https://res.cloudinary.com/oredev/image/upload/v1716803685/2024/Icons.svg/canvas_white.svg"
                        />
                        <span>{{ session.sessionTagMain }}</span>
                      </div>
                      <div
                        class="session-tag room-tag bg-yellow d-inline-block"
                        v-on:click="showMap(session.sessionScheduleRoom)"
                      >
                        <img
                          src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/door.svg"
                        />
                        <span>
                          {{ session.sessionScheduleRoom }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-on:click="toggleText(session._id)" class="row pb-3">
                    <div class="col-10 col-sm-11">
                      <span
                        style="font-size: 17px !important; font-weight: 500"
                        >{{ session.sessionTitle }}</span
                      >
                    </div>
                    <div class="col-2 col-sm-1">
                      <span
                        class="fold-icons"
                        style="position: absolute; right: 35px"
                        ><i :data-id="session._id" class="material-icons hidden"
                          >keyboard_arrow_up</i
                        ><i :data-id="session._id" class="material-icons"
                          >keyboard_arrow_down</i
                        ></span
                      >
                    </div>
                  </div>
                  <div :data-id="session._id" class="hidden">
                    <div class="row">
                      <div class="col-11">
                        <p>
                          {{ session.sessionDescription }}
                        </p>
                      </div>
                    </div>
                    <div class="row mt-1 mb-3">
                      <div class="col-12">
                        <div class="session-tag bg-yellow d-inline-block mr-1">
                          <img
                            src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/calendar.svg"
                            style="margin-bottom: 2px"
                          />
                          <span>{{
                            getDay(session.sessionScheduleDay + "")
                          }}</span>
                        </div>
                        <div class="session-tag bg-yellow d-inline-block">
                          <img
                            src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/clock.svg"
                            style="margin-bottom: 2px"
                          />
                          <span
                            >{{ session.start }}
                            {{ getAmOrPm(session.start) }}
                            {{ session.end }} &#8594;
                            {{ session.sessionlength }} min</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-2 order-md-3 col-6 order-2"
                  style="padding-top: 10px"
                  v-on:click="setSchedule(session._id), showToast()"
                >
                  <a class="btn btn-schedule float-right">Remove</a>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- red square of dots-->
      <b-img
        class="position-absolute d-none d-lg-block"
        style="width: 11%; right: 2%; top: 150px; z-index: 0"
        src="https://res.cloudinary.com/oredev/image/upload/v1712254780/2024/Asset_38_3x.png"
      ></b-img>
      <!-- Pink triangle -->
      <b-img
        class="position-absolute d-none d-lg-block"
        style="width: 12%; left: 7%; top: 600px; z-index: 0"
        src="https://res.cloudinary.com/oredev/image/upload/v1712048063/2024/pink-triangle.png"
      ></b-img>
      <!-- blue yellow circle-->
      <b-img
        class="position-absolute d-none d-lg-block"
        style="width: 8%; right: 1%; top: 900px; z-index: 0"
        src="https://res.cloudinary.com/oredev/image/upload/v1712048064/2024/Asset_6.png"
      ></b-img>
    </b-container>
    <Map></Map>
    <b-modal
      fluid
      centered
      size="md"
      ref="speaker"
      id="saveschedule"
      class=""
      style="font-family: Outfit"
      title="Save my schedule"
      hide-footer
    >
      <div v-if="!this.myscheduleid">
        <b-form @submit="saveSchedule">
          <b-form-group
            id="input-group-1"
            label="Email address:"
            label-for="input-1"
            description="You will receive an email with a link to your schedule"
          >
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              required
              placeholder="Enter email"
            >
            </b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary " class="border-0"
            >Submit</b-button
          >
        </b-form>
      </div>
      <div v-if="this.myscheduleid">
        <strong>Thanks for saving your schedule</strong>
        <p>Please have a look in your inbox.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { tagsMixin } from "../mixins/tagsMixin";
import Spinner from "../components/Spinner";
import Map from "../components/Map";
import Toast from "../components/Toast";

export default {
  name: "myschedule",
  components: {
    Spinner,
    Map,
    Toast,
  },
  watch: {
    $route(to, from) {
      /* if (to.path != from.path) {
        this.myscheduleid = this.$route.params.id;
        this.getSchedule();
      } */
    },
  },
  data() {
    return {
      form: {
        email: "",
      },
      doctitle: "My Schedule - " + this.$store.state.conferencename,
      showingToast: false,
    };
  },
  created() {},
  updated: function () {},
  mounted: function () {
    this.getSchedule();
  },
  mixins: [tagsMixin],
  methods: {
    saveSchedule: function (evt) {
      evt.preventDefault();
      const email = this.form.email;
      if (email) {
        this.createSchedule(email);
      }
    },
    getAmOrPm(time) {
      const hour = parseInt(time.split(":")[0], 10); // Extrahera timmen och konvertera till ett tal
      return hour < 12 ? "am" : "pm";
    },
    showToast() {
      this.showingToast = true;
    },
    displayDay(index) {
      // Get the current session's day
      const currentDay = this.mySessions[index].sessionScheduleDay;

      // Check if this is the first time this day has appeared in the array
      return (
        index === 0 ||
        this.mySessions[index - 1].sessionScheduleDay !== currentDay
      );
    },
  },
  computed: {
    mySessions() {
      return this.$store.getters.getSessions.filter((session) =>
        this.schedule.includes(session._id)
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
h2,
h3,
h4,
h5 {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
}

h2 {
  font-family: Outfit;
  font-size: 20px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}

p {
  color: $text-dark;
}

.row.session {
  display: none !important;
  opacity: 0.3;
}
.row.session.active {
  display: flex !important;
  opacity: 1;
}
.weekday {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-size: 18px;
  color: #1e1c1d;
  background-color: $bg-light !important;
}

.btn-schedule {
  text-decoration: none !important;
  font-weight: 400 !important;
  font-size: 20px !important;
  line-height: 25.2px;
}
.btn-schedule:hover {
  background: #d89338 !important;
  border: 2px solid #d89338 !important;
}

.session-tag {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 17.64px;
  letter-spacing: 0.05em;
  text-align: center;
  padding: 5px;
  padding: 4px 13px 4px 13px;
  border-radius: 5px;
}
.room-tag {
  cursor: pointer;
  border-radius: 30px;
}
.room-tag:hover {
  background: #d89338 !important;
}
// tagcolors
.tag-Keynote,
.tag-Architecture,
.tag-Leadership {
  background-color: #e34407;
  color: white;
}
.tag-Web,
.tag-JVM {
  background-color: #de9fc2;
}
.tag-AI,
.tag-OFF {
  background-color: #3f875d;
  color: white;
}
.tag-Security,
.tag-Data,
.tag-DATA {
  background-color: $yellow;
}
.tag-Cloud,
.tag-NET,
.tag-Quality {
  background-color: $blue;
  color: white;
}

@media screen and (max-width: 767px) {
  h5 {
    line-height: 25.2px;
    font-size: 30px !important;
  }
}
@media screen and (min-width: 767px) {
  .session-content {
    padding-left: 25px;
    padding-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MySchedule.vue